// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"952d9e27","306":"4b65b39d"}[chunkId] + ".chunk.css";
};